import React from "react";
import GoogleMap from "./fun-google-map";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_common } from "../../classes/dto-common";
import { Colors } from "../../util/colors";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { REQUEST_LOCATION } from "../../functions/mobile-intigrator";
import Alert from "../Alert";

export default class GoogleMapComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      Cordinates: { lat: 0, lng: 0 },
      ready: false,
    };
  }

  async componentDidMount() {
    await REQUEST_LOCATION();
    await GET_SET_STORED_DATA();
    this.setState({ c: 1 });

    setTimeout(async () => {
      await GET_SET_STORED_DATA();

      if (dto_common.MobileCordinate !== "") {
        if (
          dto_common.MobileCordinate === "0" ||
          dto_common.MobileCordinate === 0
        ) {
          this.setDefaulTDbLocation();
          return;
        } else {
          let ObjdefaultLocation = dto_common.MobileCordinate.split(",");
          if (ObjdefaultLocation.length === 2) {
            this.setState({
              Cordinates: {
                lat: parseFloat(ObjdefaultLocation[0]),
                lng: parseFloat(ObjdefaultLocation[1]),
              },
              ready: true,
            });
            return;
          }
        }
      }

      if (navigator.geolocation) {
        try {
          const cords = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });

          if (cords !== undefined) {
            this.setState({
              Cordinates: {
                lat: cords.coords.latitude,
                lng: cords.coords.longitude,
              },
              ready: true,
            });
            return;
          } else {
            this.setDefaulTDbLocation();
            return;
          }
        } catch (error) {
          this.setDefaulTDbLocation();
          return;
        }
      } else {
        this.setDefaulTDbLocation();
        return;
      }
    }, 1500);
  }

  setDefaulTDbLocation() {
    Alert.MessageBox({
      Tittle: "Locaton service denied",
      Text: "Please enable location service to pick exact location",
      ConfirmButtonText: "Ok",
      ConfirmButtonFunction: () => {
        let defaultLocation = dto_StartupPageLoadInfo.DefaultLocation;
        let ObjdefaultLocation = defaultLocation.split(",");
        if (ObjdefaultLocation.length === 2) {
          this.setState({
            Cordinates: {
              lat: parseFloat(ObjdefaultLocation[0]),
              lng: parseFloat(ObjdefaultLocation[1]),
            },
            ready: true,
          });
        } else {
          this.setState({
            Cordinates: { lat: 0, lng: 0 },
            ready: true,
          });
        }
      },
    });
  }

  render() {
    return (
      <>
        {this.state.ready ? (
          <div
            style={{
              marginTop: 10,
              border: "2px solid " + Colors.DarkGreyScale,
            }}
          >
            <GoogleMap
              ApiKey={"AIzaSyApHlIKZQf1ZFSNMecTXlFoxj7U67PftWo"}
              Cordinates={this.state.Cordinates}
              Zoom={this.props.Zoom}
              onMapClick={(e) => {
                this.setState({
                  Cordinates: {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                  },
                });
              }}
              onMarkerMove={(e) => {
                this.props.OnMarkerChange(e);
              }}
            />
          </div>
        ) : (
          <div
            className="loader"
            style={{ marginTop: "40%", marginBottom: "40%", marginLeft: "45%" }}
          />
        )}
      </>
    );
  }
}
